import './Footer.scss';

import { Fragment, useMemo } from 'react';
import { Container } from 'react-bootstrap';

import { HIPAA_URL, PRIVACY_NOTICE_URL, TERMS_OF_SERVICE_URL } from '@constants/constants';

const Footer = () => {
  const navItems = useMemo(
    () => [
      {
        label: 'HIPAA Notice of Privacy Practices',
        url: HIPAA_URL,
      },
      {
        label: 'Terms of Service',
        url: TERMS_OF_SERVICE_URL,
      },
      {
        label: 'Privacy Notice',
        url: PRIVACY_NOTICE_URL,
      },
    ],
    [],
  );

  return (
    <footer className='bg-white pt-3 pb-4'>
      <Container fluid='xxl' className='d-flex flex-column gap-3'>
        <nav className='footer-nav me-3' aria-label='secondary'>
          <ul>
            {navItems.map((item, index) => (
              <Fragment key={item.label}>
                {index !== 0 && <li role='presentation'>|</li>}
                <li>
                  <a href={item.url} target='_blank' rel='noopener noreferrer'>
                    {item.label}
                  </a>
                </li>
              </Fragment>
            ))}
          </ul>
        </nav>
        <p className='text-secondary fs-xs'>
          MyOme is not responsible for the content or accuracy of third-party websites.
        </p>
        <p className='text-secondary fs-xs'>
          MyOme&apos;s tests are developed, and the performance characteristics determined, by MyOme, Inc., a clinical
          laboratory certified under the Clinical Laboratory Improvement Amendments of 1988 (CLIA) to perform high
          complexity clinical laboratory testing. MyOme&apos;s tests have not been cleared or approved by the U.S. Food
          and Drug Administration (FDA). MyOme Inc. is College of American Pathologists (CAP) accredited and CLIA
          certified.
        </p>
      </Container>
    </footer>
  );
};

export default Footer;
